<template>
  <div class="flex flex-col gap-1.5">
    <label v-if="props.label" class="text-[13px] font-semibold text-foreground pl-0.5">{{ props.label }}</label>
    <input :name="props.name" :value="props.modelValue" @input="updateValue"
      :required="required" type="text"
      class="w-full h-[46px] px-4 rounded-xl text-[14px] font-medium bg-card text-foreground it-input transition duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-apex-blue-500/40 focus:border-apex-blue-500" />
    <ErrorMessage v-if="error" :error="error" />
  </div>
</template>

<script setup lang="ts">
import ErrorMessage from './ErrorMessage.vue';
const props = withDefaults(defineProps<{
  label?: string
  name: string
  modelValue: string,
  error?: string,
  required?: boolean
}>(), {
  label: '',
  name: '',
});
const emit = defineEmits(['update:modelValue']);
const updateValue = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement).value);
};
</script>

<style scoped>
/* ── Light mode ── */
.it-input {
  border: 1.5px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}
.it-input::placeholder {
  color: rgba(0, 0, 0, 0.32);
  font-weight: 400;
}

/* ── Dark mode ── */
:is(.dark *).it-input {
  border: 1.5px solid rgba(6, 200, 255, 0.10);
  box-shadow: 0 1px 6px rgba(6, 200, 255, 0.04);
}
:is(.dark *).it-input::placeholder {
  color: rgba(255, 255, 255, 0.30);
}
</style>
